export enum TargetType {
  istd = 'ISTD',
  deleted = 'DELETED_BY_USER',
  manual = 'MANUAL_COMPOUND',
  invalid = 'INVALID_TARGET',
  confirmed = 'CONFIRMED',
  unconfirmed = 'UNCONFIRMED',
}
